import React, { useState } from "react";
import styled from "@emotion/styled";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import { Form } from "antd";

import Header from "./Header";
import CowMilk, {
  flavoured,
  noFlavoured,
  soyMilkFlavoured,
  soyMilkNoFlavoured,
} from "./CowMilk";
import Vegetable from "./Vagetable";
import Excercise from "./Excercise";
import SweetDrink, { normalSweet, sweetLess } from "./SweetDrink";
import Summary from "./Summary";
import SummaryDemo from "./SummaryDemo";

import ConfirmModal from "../../components/Modal/ConfirmModal";
import { onInform } from "../../stores/inform";

import HelpIcon from "../../assets/icons/help-circle.svg";

const Inform = () => {
  const navigate = useNavigate();
  const [state, setState] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [disabled, setDisabled] = useState(true);
  const dispatch = useDispatch();

  const { role = [] } = useSelector((s) => s.auth.userInfo);
  const { isCompleted } = useSelector((s) => s.inform);
  const isStudent = role.includes("student");

  const goToHelper = () => {
    if (state === 0) window.open("/monkHelper/milk");
    else if (state === 1) window.open("/monkHelper/veggie");
    else if (state === 2) window.open("/monkHelper/move");
    else if (state === 3) window.open("/monkHelper/sweet");
  };

  const {
    currentWeek: weeks = 1,
    currentStep: steps = 1,
    maxStep: maxSteps = 3,
  } = useSelector((s) => s.auth.informInfo);

  const [form] = Form.useForm();

  const validate = (state) => {
    const values = form.getFieldsValue(true);
    if (state === 0) {
      if (values.haveDrunkCowMlik === false) {
        setDisabled(false);
        return;
      }
      if (values.haveDrunkCowMlik === true) {
        setDisabled(true);
        if (values.noFlavoured && values.noFlavoured.includes("noFlavoured")) {
          if (noFlavoured.some(({ name }) => values[name])) setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        if (values.flavoured && values.flavoured.includes("flavoured")) {
          if (flavoured.some(({ name }) => values[name])) setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        if (
          values.soyMilkNoFlavoured &&
          values.soyMilkNoFlavoured.includes("soyMilkNoFlavoured")
        ) {
          if (soyMilkNoFlavoured.some(({ name }) => values[name]))
            setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        if (
          values.soyMilkFlavoured &&
          values.soyMilkFlavoured.includes("soyMilkFlavoured")
        ) {
          if (soyMilkFlavoured.some(({ name }) => values[name]))
            setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        return;
      }

      setDisabled(true);
      return;
    } else if (state === 1) {
      if (values.haveEatenVegetable === false) {
        setDisabled(false);
        return;
      }
      if (values.haveEatenVegetable === true) {
        if (values.vegetableCount) setDisabled(false);
        else {
          setDisabled(true);
          return;
        }
      }
      return;
    } else if (state === 2) {
      if (values.haveExercised === false) {
        setDisabled(false);
        return;
      }
      if (values.haveExercised === true) {
        if (values.exerciseTime) setDisabled(false);
        else {
          setDisabled(true);
          return;
        }
      }
      return;
    } else if (state === 3) {
      if (values.haveDrunkSweetDrink === false) {
        setDisabled(false);
        return;
      }
      if (values.haveDrunkSweetDrink === true) {
        setDisabled(true);
        if (values.normalSweet && values.normalSweet.includes("normalSweet")) {
          if (normalSweet.some(({ name }) => values[name])) setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        if (values.sweetLess && values.sweetLess.includes("sweetLess")) {
          if (sweetLess.some(({ name }) => values[name])) setDisabled(false);
          else {
            setDisabled(true);
            return;
          }
        }
        return;
      }

      setDisabled(true);
      return;
    } else if (state === 4) {
      setDisabled(false);
      return;
    }
  };

  return (
    <Container>
      <Background isOther={state === 4 && !isStudent}>
        <Form
          form={form}
          name="nutrition"
          layout="vertical"
          autoComplete="off"
          onValuesChange={() => {
            validate(state);
            setFormValues(form.getFieldsValue(true));
          }}
        >
          {!(state === 4 && !isStudent) && (
            <Header
              weeks={weeks}
              steps={steps}
              maxSteps={maxSteps}
              state={state}
              onChangeState={(newState) => {
                setState(newState);
                validate(newState);
              }}
            />
          )}
          {state === 0 && (
            <CowMilk
              form={formValues}
              setFieldsValue={(value) => {
                form.setFieldsValue(value);
                setFormValues(form.getFieldsValue(true));
                validate(state);
              }}
            />
          )}
          {state === 1 && <Vegetable form={formValues} />}
          {state === 2 && <Excercise form={formValues} />}
          {state === 3 && (
            <SweetDrink
              form={formValues}
              setFieldsValue={(value) => {
                form.setFieldsValue(value);
                setFormValues(form.getFieldsValue(true));
                validate(state);
              }}
            />
          )}
          {state === 4 && isStudent && <Summary form={formValues} />}
          {state === 4 && !isStudent && <SummaryDemo />}
        </Form>

        {state < 4 && (
          <HelpButton
            onClick={() => {
              goToHelper();
            }}
          >
            <HelpIconImg src={HelpIcon} />
            <HelpLabel>ทำไม่ถึงเป้าหมายขอตัวช่วย</HelpLabel>
          </HelpButton>
        )}
        {!(state === 4 && !isStudent) && (
          <NextButton
            disabled={disabled}
            onClick={() => {
              if (state < 4) {
                setDisabled(true);
                setState(state + 1);
                validate(state + 1);
              } else {
                setConfirmModal(true);
              }
            }}
          >
            {state < 4 ? "ต่อไป" : "บันทึกข้อมูล"}
          </NextButton>
        )}
      </Background>
      <ConfirmModal
        visible={confirmModal}
        onCancel={() => setConfirmModal(false)}
        onSubmit={() => {
          const data = {
            freshMilkSUnit: 0,
            freshMilkMUnit: 0,
            freshMilkLUnit: 0,
            flavoredMilkSUnit: 0,
            flavoredMilkMUnit: 0,
            flavoredMilkLUnit: 0,
            soyMilkSUnit: 0,
            soyMilkMUnit: 0,
            soyMilkLUnit: 0,
            soyMilkSweetSUnit: 0,
            soyMilkSweetMUnit: 0,
            soyMilkSweetLUnit: 0,
            vegetableQuantity: 0,
            exerciseMinutes: 0,
            normalSweetDrinkSUnit: 0,
            normalSweetDrinkMUnit: 0,
            normalSweetDrinkLUnit: 0,
            lowSweetDrinkSUnit: 0,
            lowSweetDrinkMUnit: 0,
            lowSweetDrinkLUnit: 0,
          };
          const formValues = form.getFieldsValue(true);
          if (formValues.haveDrunkCowMlik) {
            if (
              formValues.noFlavoured &&
              formValues.noFlavoured.includes("noFlavoured")
            ) {
              data.freshMilkSUnit = formValues.freshMilkSUnit || 0;
              data.freshMilkMUnit = formValues.freshMilkMUnit || 0;
              data.freshMilkLUnit = formValues.freshMilkLUnit || 0;
            }
            if (
              formValues.flavoured &&
              formValues.flavoured.includes("flavoured")
            ) {
              data.flavoredMilkSUnit = formValues.flavoredMilkSUnit || 0;
              data.flavoredMilkMUnit = formValues.flavoredMilkMUnit || 0;
              data.flavoredMilkLUnit = formValues.flavoredMilkLUnit || 0;
            }
            if (
              formValues.soyMilkNoFlavoured &&
              formValues.soyMilkNoFlavoured.includes("soyMilkNoFlavoured")
            ) {
              data.soyMilkSUnit = formValues.soyMilkSUnit || 0;
              data.soyMilkMUnit = formValues.soyMilkMUnit || 0;
              data.soyMilkLUnit = formValues.soyMilkLUnit || 0;
            }
            if (
              formValues.soyMilkFlavoured &&
              formValues.soyMilkFlavoured.includes("soyMilkFlavoured")
            ) {
              data.soyMilkSweetSUnit = formValues.soyMilkSweetSUnit || 0;
              data.soyMilkSweetMUnit = formValues.soyMilkSweetMUnit || 0;
              data.soyMilkSweetLUnit = formValues.soyMilkSweetLUnit || 0;
            }
          }
          if (formValues.haveEatenVegetable) {
            data.vegetableQuantity = formValues.vegetableCount;
          }
          if (formValues.haveExercised) {
            data.exerciseMinutes = formValues.exerciseTime;
          }
          if (formValues.haveDrunkSweetDrink) {
            if (
              formValues.normalSweet &&
              formValues.normalSweet.includes("normalSweet")
            ) {
              data.normalSweetDrinkSUnit =
                formValues.normalSweetDrinkSUnit || 0;
              data.normalSweetDrinkMUnit =
                formValues.normalSweetDrinkMUnit || 0;
              data.normalSweetDrinkLUnit =
                formValues.normalSweetDrinkLUnit || 0;
            }
            if (
              formValues.sweetLess &&
              formValues.sweetLess.includes("sweetLess")
            ) {
              data.lowSweetDrinkSUnit = formValues.lowSweetDrinkSUnit || 0;
              data.lowSweetDrinkMUnit = formValues.lowSweetDrinkMUnit || 0;
              data.lowSweetDrinkLUnit = formValues.lowSweetDrinkLUnit || 0;
            }
          }

          dispatch(onInform(data));
        }}
        hasConfirmationBeenCompleted={isCompleted}
        topic="บันทึกข้อมูล 4 เป้าหมาย"
        remark="บันทึกข้อมูลแล้ว"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;

  display: flex;
  justify-content: center;
  align-items: center;

  .ant-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-bottom: ${(props) => (props.isOther ? "0px" : "80px")};

  ${(props) =>
    responsive.tablet(css`
      max-width: unset;
      padding-bottom: ${props.isOther ? "0px" : "50px"};
    `)}

  ${(props) =>
    responsive.mobile(css`
      padding-bottom: ${props.isOther ? "0px" : "40px"};
    `)}
`;

const HelpButton = styled.div`
  width: 332px;
  height: 56px;

  background: #b5f6df;

  border: 1px solid #16af7b;
  border-radius: 100px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 24px;
  cursor: pointer;

  ${responsive.mobile(css`
    width: 343px;
    height: 51px;
  `)}
`;

const HelpLabel = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  line-height: 28px;

  letter-spacing: -0.02em;

  color: #16af7b;

  ${responsive.mobile(css`
    font-size: 19px;
    line-height: 23px;
    font-weight: 600;
  `)}
`;

const HelpIconImg = styled.img`
  width: 13.33px;
  height: 13.33px;

  margin-right: 9.33px;
`;

const NextButton = styled.button`
  width: 206px;
  height: 51px;
  left: calc(50% - 206px / 2);
  top: 0px;

  background: ${(props) => (props.disabled ? "#d0d5dd" : "#16AF7B")};
  border: none;
  border-radius: 100px;

  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 23px;

  letter-spacing: -0.02em;

  color: ${(props) => (props.disabled ? "#64748b" : "white")};

  cursor: ${(props) => (props.disabled ? "" : "pointer")};
`;

export default Inform;
